var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"child"},[_vm._v(" "+_vm._s(_vm.value)+" "),_c('v-text-field',{attrs:{"outlined":""},on:{"change":_vm.UpdateData},model:{value:(_vm.value[0].name),callback:function ($$v) {_vm.$set(_vm.value[0], "name", $$v)},expression:"value[0].name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }